import { render, staticRenderFns } from "./produktEditPanel.vue?vue&type=template&id=1b3673c5&scoped=true&"
import script from "./produktEditPanel.vue?vue&type=script&lang=js&"
export * from "./produktEditPanel.vue?vue&type=script&lang=js&"
import style0 from "./produktEditPanel.vue?vue&type=style&index=0&id=1b3673c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3673c5",
  null
  
)

export default component.exports